import React from "react";
import { Container, Row, Col } from "reactstrap";
import { StepperProvider, useStepperContext } from "./StepperContext";
import StepperHeader from "./StepperHeader";
import StepperContent from "./StepperContent";
import StepperNavigation from "./StepperNavigation";

const StepperNavigationAdapter = ({ disableNext, onComplete }) => {
  const { currentStep } = useStepperContext();

  const isDisabled =
    typeof disableNext === "function" ? disableNext(currentStep) : disableNext;

  return <StepperNavigation onComplete={onComplete} disableNext={isDisabled} />;
};

const Stepper = ({
  steps,
  children,
  onComplete,
  disableNext,
  className = "",
}) => {
  return (
    <StepperProvider steps={steps}>
      <Container className={className}>
        <Row className="justify-content-center">
          <Col md={10} lg={10}>
            <div className="stepper-container mt-4">
              <StepperHeader />
              <StepperContent>{children}</StepperContent>
              <StepperNavigationAdapter
                onComplete={onComplete}
                disableNext={disableNext}
              />
            </div>
          </Col>
        </Row>
      </Container>
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </StepperProvider>
  );
};

export default Stepper;
